import { useEffect, useState } from "react";

const TABS = [
  { id: "domains", label: "Domains" },
  { id: "breakthroughs", label: "Breakthroughs" },
  { id: "impact", label: "Impact" },
  { id: "science-for-all", label: "Science for All" },
  { id: "resources", label: "Resources" },
];

export default function AnchorTabs() {
  const [active, setActive] = useState("domains");
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => {
      const domains = document.getElementById("domains");
      if (!domains) return;
      const triggerY = domains.getBoundingClientRect().top;
      setVisible(triggerY <= 80);

      let current = "domains";
      for (const t of TABS) {
        const el = document.getElementById(t.id);
        if (!el) continue;
        const top = el.getBoundingClientRect().top;
        if (top - 120 <= 0) current = t.id;
      }
      setActive(current);
    };
    window.addEventListener("scroll", onScroll, { passive: true });
    onScroll();
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const onJump = (id) => (e) => {
    e.preventDefault();
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <div
      data-testid="anchor-tabs"
      className={`sticky top-16 z-40 transition-all duration-200 ${
        visible ? "opacity-100 translate-y-0" : "opacity-0 -translate-y-2 pointer-events-none"
      }`}
    >
      <div className="bg-white/95 backdrop-blur-md border-b border-neutral-200">
        <div className="mx-auto max-w-[1280px] px-4 md:px-6">
          <div className="flex items-center gap-6 md:gap-8 overflow-x-auto scrollbar-hide py-3">
            {TABS.map((t) => (
              <a
                key={t.id}
                href={`#${t.id}`}
                onClick={onJump(t.id)}
                data-testid={`anchor-tab-${t.id}`}
                className={`shrink-0 text-[13px] md:text-[14px] font-medium transition-colors pb-2 ${
                  active === t.id
                    ? "text-neutral-900 border-b-2 border-neutral-900 -mb-[13px]"
                    : "text-neutral-500 hover:text-neutral-900 border-b-2 border-transparent -mb-[13px]"
                }`}
              >
                {t.label}
              </a>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
